

export const routeBookingConstants = {
	
	FOR_OPTION: 'foroption',
	
	DEPTH_LEVEL: 'depthlevel',
	
	BUILDING: 'building',
	FLOOR: 'floor',
	ROOM: 'room',
	
	FORCED_TIMESLOT_GROUP_GUID: 'forcedtimeslotgroupguid',
	FORCED_BUILDING_GUID: 'forcedbuildingguid',
	FORCED_FLOOR_GUID: 'forcedfloorguid',
	FORCED_ROOM_GUID: 'forcedroomguid',
	FORCED_TIMESLOTS: 'forcedtimeslots',
	
	FORCED_TIMESLOT_1: 'forcedtimeslot1',
	FORCED_TIMESLOT_2: 'forcedtimeslot2',
	FORCED_TIMESLOT_3: 'forcedtimeslot3',
	FORCED_TIMESLOT_4: 'forcedtimeslot4',
	FORCED_TIMESLOT_5: 'forcedtimeslot5',
	FORCED_TIMESLOT_6: 'forcedtimeslot6',
	FORCED_TIMESLOT_7: 'forcedtimeslot7',
	FORCED_TIMESLOT_8: 'forcedtimeslot8',
	FORCED_TIMESLOT_9: 'forcedtimeslot9',
	FORCED_TIMESLOT_10: 'forcedtimeslot10',
	FORCED_TIMESLOT_11: 'forcedtimeslot11',
	FORCED_TIMESLOT_12: 'forcedtimeslot12',
	FORCED_TIMESLOT_13: 'forcedtimeslot13',
	FORCED_TIMESLOT_14: 'forcedtimeslot14',
	FORCED_TIMESLOT_15: 'forcedtimeslot15',
	FORCED_TIMESLOT_16: 'forcedtimeslot16',
	FORCED_TIMESLOT_17: 'forcedtimeslot17',
	FORCED_TIMESLOT_18: 'forcedtimeslot18',
	FORCED_TIMESLOT_19: 'forcedtimeslot19',
	FORCED_TIMESLOT_20: 'forcedtimeslot20',
	
	THROUGH_QR_SCAN: 'throughqrscan',
	
	TIMESLOT_GROUP: 'timeslotgroup',
	TIMESLOT_KINDS: 'timeslotkinds',
	TIMESLOT_SUB_KINDS: 'timeslotsubkinds',
}

export const routeBookingConstantValues = {
	[ routeBookingConstants.DEPTH_LEVEL ]: {
		BUILDING: 'depth_level_building',
		FLOOR: 'depth_level_floor',
		ROOM: 'depth_level_room',
	},
	[ routeBookingConstants.THROUGH_QR_SCAN ]: {
		YES: 'yes',
		NO: 'NO'
	}
}